import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ETAX_COPY_QUANTITY, getCopyTypes } from "./printCopyTypes";

const ETAX_COPY_TYPES = getCopyTypes(true);

// The one print set every e-Tax shop prints. The backend applies it whatever is saved, so
// it is shown read-only instead of an editor whose changes would have no effect.
export default function EtaxPrintSetView() {
  return (
    <Stack gap={2}>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          px: 2,
          py: 0.5,
        }}
      >
        {ETAX_COPY_TYPES.map((copyType) => (
          <Stack
            key={copyType.key}
            direction="row"
            alignItems="baseline"
            gap={1}
            sx={{
              py: 1,
              "&:not(:first-of-type)": { borderTop: "1px solid", borderColor: "divider" },
            }}
          >
            <Typography variant="body2" fontWeight={700}>
              {copyType.key}
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              {copyType.label}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              ×{ETAX_COPY_QUANTITY}
            </Typography>
          </Stack>
        ))}
      </Box>

      <Stack direction="row" alignItems="flex-start" gap={0.75} color="text.secondary">
        <InfoOutlinedIcon sx={{ fontSize: 16, mt: "2px", flexShrink: 0 }} />
        <Typography variant="caption">
          ร้านที่ใช้ e-Tax พิมพ์ต้นฉบับ (C) 1 ใบ และสำเนา (A) 1 ใบเสมอ
          จึงไม่สามารถแก้ไขชุดการพิมพ์ได้
        </Typography>
      </Stack>
    </Stack>
  );
}
